import React, {FC} from "react";
import {IIcon} from "../interfaces/IIcon";
import Icon from "@ant-design/icons";

const SVG: FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} xmlSpace="preserve" viewBox="0 0 64 64">
		<style>{`.st1{opacity:.2}.st4{fill:#fff}`}</style>
		<g id="Layer_1">
			<circle cx="32" cy="32" r="32" fill="#e0995e"/>
			<path fill="#231f20"
			      d="M44 48c0 2.2-1.8 4-4 4H24c-2.2 0-4-1.8-4-4V16c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v32z"
			      className="st1"/>
			<path fill="#4f5d73"
			      d="M24 48.5c-1.4 0-2.5-1.1-2.5-2.5V14c0-1.4 1.1-2.5 2.5-2.5h16c1.4 0 2.5 1.1 2.5 2.5v32c0 1.4-1.1 2.5-2.5 2.5H24z"/>
			<path
				d="M40 13c.6 0 1 .4 1 1v32c0 .6-.4 1-1 1H24c-.6 0-1-.4-1-1V14c0-.6.4-1 1-1h16m0-3H24c-2.2 0-4 1.8-4 4v32c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V14c0-2.2-1.8-4-4-4z"
				className="st4"/>
			<g className="st1">
				<path d="M26.2 11.5 42 49.6V11.5z" className="st4"/>
			</g>
			<path d="M40 50H24l-4-8h24z" className="st4"/>
			<circle cx="32" cy="46" r="2" fill="#e0e0d1"/>
		</g>
	</svg>
);

const IconPhone: FC<IIcon> = props => <Icon component={SVG} {...props} />;
export default IconPhone;